/* Default Colors */
/* CI/CD Colors */
/* 2021 TS Colors */
/* Scrollbars */
oebb-input-field {
  /* :host */
  display: inline-block;
}

.oebb-input-field, .oebb-input-field-wrap {
  position: relative;
}
.oebb-input-field-label-wrap {
  margin-bottom: 0.35em;
}
.oebb-input-field label {
  display: inline-block;
}
.oebb-input-field label small::before {
  content: " ";
}
.oebb-input-field .screen-reader-text {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip-path: inset(50%);
  white-space: nowrap;
}
.oebb-input-field .screen-reader-text:active, .oebb-input-field .screen-reader-text:focus {
  min-width: 200px;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip-path: none;
  white-space: inherit;
}

.oebb-input-field .icon-start, .oebb-input-field .icon-end {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}
.oebb-input-field .icon-start svg, .oebb-input-field .icon-end svg {
  vertical-align: middle;
}
.oebb-input-field .icon-start:hover, .oebb-input-field .icon-end:hover {
  cursor: pointer;
}
.oebb-input-field .icon-start {
  left: 0.75em;
}
.oebb-input-field .icon-end {
  right: 0.75em;
}

.oebb-input {
  position: relative;
  width: 100%;
  padding: 0.75em 0.5em;
  margin-bottom: 2px;
  box-sizing: border-box;
  background: #EEEEEE;
  border: none;
  border-radius: 0;
  /* iOS */
  box-shadow: 0 1px 0 0 #BABDC0;
  -webkit-appearance: none;
  /* iOS */
  font-size: 1em;
}
.oebb-input--icon-start {
  padding-left: 2.75em;
}
.oebb-input--icon-end {
  padding-right: 2.75em;
}
.oebb-input:focus, oebb-input-field.oebb-autocomplete-input-field--active .oebb-input {
  box-shadow: 0 2px 0 0 #E2002A;
  outline: none;
}
.klimaticket .oebb-input:focus, .klimaticket oebb-input-field.oebb-autocomplete-input-field--active .oebb-input {
  box-shadow: 0 2px 0 0 #04233F;
  outline: none;
}
.oebb-input--readonly {
  cursor: pointer;
}